function injectImagePlacementCSS() {
  if (document.getElementById('tee-image-placement-style')) return;

  const style = document.createElement('style');
  style.id = 'tee-image-placement-style';
  style.textContent = `
    .teeinblue-enabled .tee-dialog-image-placement .tee-ip-preview--with-mockup {
      margin-bottom: 125px;
    }
    .teeinblue-enabled .tee-dialog-image-placement .tee-toolbar {
      bottom: -125px;
    }
    .teeinblue-enabled .tee-dialog-image-placement .tee-toolbar .tee-beforeContent span {
      display: inline-block;
      font-size: 14px;
      margin-bottom: 5px;
    }
    @media only screen and (max-width: 768px) {
        .teeinblue-enabled .tee-dialog-image-placement .tee-toolbar .tee-beforeContent span {
            font-size: 12px !important;
        }
    }
    .teeinblue-enabled .tee-dialog-image-placement .tee-toolbar .tee-beforeContent span:last-child {
      margin-bottom: 10px;
    }

  `;
  document.head.appendChild(style);
}

function insertContent(rootEl) {
    const toolbar = rootEl.querySelector(".tee-toolbar");
    const beforeContent = document.createElement("div");
    beforeContent.className = "tee-beforeContent";
    beforeContent.innerHTML = `
    <span>Click “−” to shrink, long-press to drag & reposition image.
Avoid over-stretching to keep quality.</span>
    <span>Image blocked by lens or not filling screen?
Snapshell Support is here to help!
Contact us: WhatsApp or Mobile SMS +61 431 545 553, Thanks for supporting Aussie local business!</span>`

    toolbar.prepend(beforeContent);
}

function observeImagePlacementPopup() {
    injectImagePlacementCSS();
    const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType === 1 && node.classList.contains("tee-dialog-image-placement")) {
                    setTimeout(() => {
                        insertContent(node);
                    }, 100);
                }
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('teeinblue-event-component-injected', function() {
  observeImagePlacementPopup();
})